/**
 * Check if element(s) exists, 
 * @param  {Function} cb [description]
 * @return {[type]}      [description]
 */

export default function (selector) {
  return qsa(selector).length > 0
};


// WEBPACK FOOTER //
// ./helpers/exists.js